export default {
    items: [
        {
            name: 'Лиды',
            url: '/admin/leads',
            icon: 'icon-star'
        },
        {
            name: 'Звонки',
            url: '/admin/telecalls',
            icon: 'icon-phone'
        },
        {
            name: 'Логи',
            url: '/admin/logs',
            icon: 'icon-layers'
        },
        {
            name: 'Логи ошибок',
            url: '/admin/errorlog',
            icon: 'icon-layers'
        },
        // {
        //     name: 'Архив',
        //     url: '/admin/archive',
        //     icon: 'icon-question'
        // },
        {
            name: 'Заявки',
            url: '/admin/orders',
            icon: 'icon-bag'
        },
        // {
        //     name: 'FIX', // НСБ › Система › FIX
        //     url: '/admin/fix',
        //     icon: 'icon-wrench'
        // },
        {
            name: 'Путевки',
            url: '/admin/vouchers',
            icon: 'icon-briefcase'
        },
        {
            name: 'Компании',
            url: '/admin/companies',
            icon: 'icon-people'
        },
        {
            name: 'Пользователи',
            url: '/admin/users',
            icon: 'icon-user'
        },
        {
            name: 'Админские заметки',
            url: '/admin/help',
            icon: 'fa fa-info'
        },

        {
            name: 'КА - Состояния',
            url: '/admin/sm/states',
            icon: 'fa fa-share-alt-square',
        },
        {
            name: 'КА - Условия',
            url: '/admin/sm/conditions',
            icon: 'fa fa-share-alt-square',
        },
        {
            name: 'КА - Функции',
            url: '/admin/sm/functions',
            icon: 'fa fa-share-alt-square',
        },
        {
            name: 'КА - Переходы',
            url: '/admin/sm/operations',
            icon: 'fa fa-share-alt-square',
        },
        {
            name: 'КА - Граф',
            url: '/admin/sm/export',
            icon: 'fa fa-download',
        },
        {
            name: 'Разметка фраз',
            url: '/admin/bot-phrases',
            icon: 'fa fa-android',
        }
    ]
}
